"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", [_c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 40
    }
  }, [_c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 20,
      sm: 10,
      lg: 8
    }
  }, [_c("router-link", {
    attrs: {
      to: "/employees/list"
    }
  }, [_c("div", {
    staticClass: "card-panel",
    on: {
      click: function ($event) {
        return _vm.handleSetLineChartData("newVisitis");
      }
    }
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("Pending Avatar Verifications")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.employeesCount,
      duration: _vm.animationDuration
    }
  })], 1)])])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 20,
      sm: 10,
      lg: 8
    }
  }, [_c("div", {
    staticClass: "card-panel",
    on: {
      click: function ($event) {
        return _vm.handleSetLineChartData("newVisitis");
      }
    }
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("First Logged In Employees")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item download-button",
    attrs: {
      loading: _vm.downloadLoading,
      type: "success",
      icon: "el-icon-download"
    },
    on: {
      click: _vm.handleDownload
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.export")) + " ")])], 1), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.firstLoginEmployeesCount,
      duration: _vm.animationDuration
    }
  })], 1), _c("div", {
    staticClass: "card-panel-sub-description"
  }, [_c("b", [_vm._v("Total Employees: ")]), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.totalEmployeesCount,
      duration: _vm.animationDuration
    }
  })], 1)])])]), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 20,
      sm: 10,
      lg: 8
    }
  }, [_c("div", {
    staticClass: "card-panel",
    on: {
      click: function ($event) {
        return _vm.handleSetLineChartData("newVisitis");
      }
    }
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("b", [_vm._v("Profile Picture Uploaded")])]), _c("div", {
    staticClass: "card-panel-subtext"
  }, [_c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.profileImageUploadedCount,
      duration: _vm.animationDuration
    }
  })], 1), _c("div", {
    staticClass: "card-panel-sub-description"
  }, [_c("b", [_vm._v("Total RM: ")]), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.rmCount,
      duration: _vm.animationDuration
    }
  })], 1)])])])], 1), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 40
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;